module.exports = __webpack_public_path__ + "static/media/GivingYouHealthCard.ff67ca13.png";